export const ru = {
    show_on_a_map: 'Посмотреть на карте',
    location_in_ymap: 'расположение на Яндекс Картах',
};
